import React, { FC } from 'react'
import { Typography } from 'antd'

const { Text } = Typography

interface StatValueProps {
  label: string
  value: string
  variant?: 'dark' | 'light'
  emphasized?: boolean
}

const StatValue: FC<StatValueProps> = ({ label, value, variant = 'light', emphasized }) => {
  if (variant === 'dark') {
    return (
      <div style={{ minWidth: 120 }}>
        <Text
          style={{
            color: 'rgba(255,255,255,0.65)',
            fontFamily: 'Source Sans Pro',
            fontWeight: 600,
            fontSize: 14,
            lineHeight: '30px',
            letterSpacing: 0.2,
            whiteSpace: 'nowrap',
            display: 'block',
          }}
        >
          {label}
        </Text>
        <Text
          style={{
            color: '#fff',
            fontFamily: 'Dosis',
            fontWeight: 300,
            fontSize: emphasized ? 42 : 36,
            lineHeight: '30px',
            letterSpacing: 0.44,
          }}
        >
          {value}
        </Text>
      </div>
    )
  }

  return (
    <div style={{ flex: 1, textAlign: 'center' }}>
      <Text
        type='secondary'
        style={{
          fontFamily: 'Roboto',
          fontWeight: 400,
          fontSize: 14,
          lineHeight: '21px',
          display: 'block',
        }}
      >
        {label}
      </Text>
      <Text
        style={{
          fontFamily: 'Roboto',
          fontWeight: 500,
          fontSize: 30,
          lineHeight: '45px',
          color: 'rgba(0, 0, 0, 0.85)',
          display: 'block',
          margin: '4px 0 0',
        }}
      >
        {value}
      </Text>
    </div>
  )
}

export default StatValue
